import Animation from "@/components/Animation";
import Purchase from "@/components/orders/Purchase";
import Spinner from "@/components/Spinner";
import ErrorMsg from "./components/ErrorMsg";
import LessonPageContentMapper from "./components/LessonPageContentMapper";
import LessonPageHead from "./components/LessonPageHead";
import NotLoggedIn from "./components/NotLoggedIn";
import StudentBlocked from "./components/StudentBlocked";
import useGetLesson from "./hooks/useGetLesson";

const LessonDetails = () => {
  const {
    lessonData,
    isPending,
    error,
    isAuthenticated,
    authPending,
    notFinishedPrereq,
    prerequisiteType,
    pastLastPurchaseDate,
    isStudentBlocked,
  } = useGetLesson();

  if (!isAuthenticated) return <NotLoggedIn />;
  if (error) return <ErrorMsg />;

  if (isStudentBlocked) return <StudentBlocked />;

  if (isPending || authPending)
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <Spinner />
      </div>
    );

  if (lessonData?.is_purchased || lessonData?.is_author)
    return (
      <Animation>
        <div id="lesson-page-container" className="container mx-auto sm:max-w-[60%] p-8">
          <LessonPageHead lessonData={lessonData} />

          <LessonPageContentMapper lessonData={lessonData} />
        </div>
      </Animation>
    );

  if (notFinishedPrereq)
    return (
      <Animation expand={false}>
        <div className="container mx-auto sm:max-w-[60%] p-8">
          <div
            role="alert"
            className="m-5 w-full rounded-lg bg-red-100 border border-red-400 text-red-700 px-4 py-3"
          >
            يجب إنهاء {prerequisiteType === 'quiz' ? 'كويز' : 'واجب'} الحصة السابقة، إذا كانت هذه الحصة الأولى لك مع المدرس
            برجاء التواصل مع المدرس
          </div>
        </div>
      </Animation>
    );

  if (pastLastPurchaseDate)
    return (
      <Animation expand={false}>
        <div className="container mx-auto sm:max-w-[60%] p-8">
          <div
            role="alert"
            className="m-5 w-full rounded-lg bg-red-100 border border-red-400 text-red-700 px-4 py-3"
          >
            إنتهى الوقت المسموح لشراء الحصة، تواصل مع المدرس
          </div>
        </div>
      </Animation>
    );

  return (
    <Animation>
      <div className="container mx-auto sm:max-w-[60%] p-8">
        <LessonPageHead lessonData={lessonData} />
        <Purchase lessonData={lessonData} />
      </div>
    </Animation>
  );
};

export default LessonDetails;
